import { Checkbox } from "antd";
import { useParams } from "react-router-dom";
import InfoItem from "../../../../../components/common/InfoItem";
import Loader from "../../../../../components/ui/Loader";
import { useRoleStatusQuery } from "../../../../../features/emp-setting/employee/employeeApi";
import { useGetProjectsByUserQuery } from "../../../../../features/portal/Products/productsApi";
import useError from "../../../../../hooks/useError";
import { GetSingleUserDataType } from "../../../../../types/portal/user";
import { capitalize } from "../../../../../utils/string";
import EditButtonEmployee from "./EditButtonEmployee";

type Props = {
  data?: GetSingleUserDataType;
};

export default function UserAccessPermission({ data }: Props) {
  const { viewId } = useParams();
  const {
    isError: isRoleError,
    error: roleError,
    isLoading: isRoleLoading,
    data: roleData,
  } = useRoleStatusQuery(String(viewId), {
    skip: !viewId,
  });
  const {
    isError,
    error,
    isLoading,
    data: projectData,
  } = useGetProjectsByUserQuery(
    {
      params: {
        userid: viewId,
      },
    },
    {
      skip: !viewId,
    }
  );
  useError(isRoleError, roleError, "Get role fail");
  useError(isError, error, "Get project fail");
  const isSelectedUserCompanyAdmin =
    roleData?.data?.selectedUserIsCompanyAdmin ?? false;
  const isSelectedUserHRAdmin =
    roleData?.data?.selectedUserIsHRAdmin2 ?? false;

  return (
    <ul>
      <li className="text-slate-600 text-base font-semibold px-3 py-1.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-2.5 w-full">
        User Role Permission
      </li>
      {isRoleLoading || isLoading ? (
        <Loader />
      ) : (
        <>
          {/* <InfoItem rootClassName="!py-3" className="space-x-1">
            <Checkbox checked={roleData?.data?.isSuperAdmin} />{" "}
            <span className="text-accent">Assign as Super Admin</span>
          </InfoItem> */}
          <InfoItem rootClassName="!py-3" className="space-x-1">
            <Checkbox
              className="cursor-default"
              checked={isSelectedUserCompanyAdmin}
            />{" "}
            <span className="text-accent">Assign as Company Admin</span>
          </InfoItem>
          <InfoItem rootClassName="!py-3" className="space-x-1">
            <Checkbox
              className="cursor-default"
              checked={isSelectedUserHRAdmin}
            />{" "}
            <span className="text-accent">Assign as HR Admin</span>
          </InfoItem>
          {projectData?.data?.map((el, idx) => (
            <InfoItem
              rootClassName="!py-3 !grid !grid-cols-2 gap-2"
              titleClassName="!text-accent"
              className="space-x-1"
              title={el?.project?.name}
              key={idx}
            >
              {el?.role?.roleName === "edatco"
                ? "Admin"
                : el?.role?.roleName === "region"
                ? "Zonal"
                : el?.role?.roleName?.length <= 3
                ? el?.role?.roleName?.toUpperCase()
                : capitalize(el?.role?.roleName) || "N/A"}
            </InfoItem>
          ))}
        </>
      )}

      {data?.data?.status !== "invited" && (
        <EditButtonEmployee type="User Access Permission" />
      )}
    </ul>
  );
}
